import React, { useState } from 'react'

//components
import CountsTable from './CountsTable'
import CountsDrawer from './CountsDrawer'
import InventoryTabsHeader from '../InventoryTabsHeader'
import InventoryTabsContent from '../InventoryTabsContent'

function CountsTab(props) {
  const [showDrawer, setShowDrawer] = useState(false)
  const [fetchData, setFetchData] = useState(true)
  const [searchText, setSearchText] = useState('')

  const onSearch = searchText => {
    setSearchText(searchText)
  }

  return (
    <div>
      <InventoryTabsHeader
        shopsList={props.shopsList}
        selectedOption={props.selectedOption}
        setSelectedOption={option => {
          props.setSelectedOption(option)
        }}
        onSearch={onSearch}
        buttonLabel={'Nuevo conteo'}
        buttonHandler={() => {
          setShowDrawer(true)
        }}
        createPermissions={38}
        keyTab={props.keyTab}
      />
      <InventoryTabsContent
        fetchData={fetchData}
        component={CountsTable}
        selectedOption={props.selectedOption}
        searchText={searchText}
        keyTab={props.keyTab}
      />
      <CountsDrawer
        shopsList={props.shopsList}
        closable={() => setShowDrawer(false)}
        setFetchData={setFetchData}
        visible={showDrawer}
        fetchData={fetchData}
      />
    </div>
  )
}

export default CountsTab

CountsTab.defaultProps = {
  selectedOption: null,
  shopsList: [],
}
